//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../ModlDirect/ModlDirect.SelectBlend.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ModlDirect.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"Axis",1,"Axis",0],[1,"BlendFaces",0,"ModlDirect.SelectBlend",0],[0,"Copy",1,0],[0,"Direction",1,"Direction",0],[1,"Distance",0,"Expression",0],[0,"FromPoint",1,"Point",0],[0,"FromVector",1,"Direction",0],[1,"MoveFaceCollector",0,"ScCollector",0],[0,"PivotPoint",1,"Point",0],[0,"ToPoint",1,"Point",0],[0,"ToVector",1,"Direction",0],[0,"Type",1,0]],[],[]];
SPLM.Features.MoveFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MoveFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MoveFaceBuilder.Types = Object.freeze({
    "TranslateDirectionAndDistance" : "TranslateDirectionAndDistance", "TranslateBetweenTwoPoints" : "TranslateBetweenTwoPoints", "RotateAboutAxis" : "RotateAboutAxis", "RotateBetweenTwoAxes" : "RotateBetweenTwoAxes"});

export default SPLM;